// Auto generated file, do not manually modify!
// com.hotpads.renterinfo.web.api.web.v1.renterprofile.enums.RenterProfileStandalonePagePreferredBedroomCount

export enum RenterProfileStandalonePagePreferredBedroomCount {
  FOUR_PLUS_BDS = '4_PLUS_BDS',
  ONE_BD = '1_BD',
  STUDIO = 'STUDIO',
  THREE_BDS = '3_BDS',
  TWO_BDS = '2_BDS',
}

export const RenterProfileStandalonePagePreferredBedroomCount_values = [
  RenterProfileStandalonePagePreferredBedroomCount.FOUR_PLUS_BDS,
  RenterProfileStandalonePagePreferredBedroomCount.ONE_BD,
  RenterProfileStandalonePagePreferredBedroomCount.STUDIO,
  RenterProfileStandalonePagePreferredBedroomCount.THREE_BDS,
  RenterProfileStandalonePagePreferredBedroomCount.TWO_BDS,
] as const;
